export enum LineupType {
	Gameday = 'gameday',
	Travel = 'travel',
	Practice = 'practice',
}